import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
}));

const QueueSelect = ({ 
	selectedQueueIds = [], 
	selectedQueueOptionIds = [],
	onChange, 
	multiple = true, 
	title = i18n.t("queueSelect.inputLabel") 
}) => {
	const classes = useStyles();
	const [queues, setQueues] = useState([]);

	useEffect(() => {

		fetchQueues();

	}, []);

	const fetchQueues = async () => {
		try {
			const { data } = await api.get("/queue");
			setQueues(data);
		} catch (err) {
			toastError(err);
		}
	}

	const handleChange = e => {
		let values = e.target.value;
		if (!Array.isArray(values)) {
			values = values ? [values] : [];
		}
		const qIds = values.filter(v => typeof v === 'number');
		const qoIds = values.filter(v => typeof v === 'string' && v.startsWith('opt-')).map(v => parseInt(v.split('-')[1]));
		
		if (multiple) {
			onChange(qIds, qoIds);
		} else {
			onChange(qIds.length > 0 ? qIds[0] : (qoIds.length > 0 ? `opt-${qoIds[0]}` : null));
		}
	};

	let combinedSelected;
	if (multiple) {
		combinedSelected = [
			...(Array.isArray(selectedQueueIds) ? selectedQueueIds : (selectedQueueIds ? [selectedQueueIds] : [])),
			...(Array.isArray(selectedQueueOptionIds) ? selectedQueueOptionIds.map(id => `opt-${id}`) : (selectedQueueOptionIds ? [`opt-${selectedQueueOptionIds}`] : []))
		];
	} else {
		combinedSelected = selectedQueueIds ? selectedQueueIds : (selectedQueueOptionIds ? `opt-${selectedQueueOptionIds}` : "");
	}

	return (
		<div >
			<FormControl fullWidth margin="dense" variant="outlined">
				<InputLabel shrink={selectedQueueIds ? true : false} >{title}</InputLabel>
				<Select
					label={title}
					multiple={multiple}
					labelWidth={60}
					value={combinedSelected}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}

					renderValue={selected => {
						return (
							<div className={classes.chips}>
								{selected?.length > 0 && multiple ? (
									selected.map(val => {
										const isOpt = typeof val === 'string' && val.startsWith('opt-');
										const id = isOpt ? parseInt(val.split('-')[1]) : val;
										
										let queue = null;
										let name = "";
										let color = "";
										
										if (isOpt) {
											queues.forEach(q => {
												const opt = q.options?.find(o => o.id === id);
												if (opt) {
													queue = q;
													name = `${q.name} - ${opt.title}`;
													color = q.color;
												}
											});
										} else {
											queue = queues.find(q => q.id === id);
											if (queue) {
												name = queue.name;
												color = queue.color;
											}
										}

										return queue ? (
											<Chip
												key={val}
												style={{ backgroundColor: color }}
												variant="outlined"
												label={name}
												className={classes.chip}
											/>
										) : null;
									})

								) :
									(
										<Chip
											key={selected}
											variant="outlined"
											style={{ backgroundColor: queues.find(q => q.id === selected)?.color }}
											label={queues.find(q => q.id === selected)?.name}
											className={classes.chip}
										/>
									)
								}

							</div>
						)
					}}
				>
					{!multiple && <MenuItem value={null}>Nenhum</MenuItem>}
					{queues.map(queue => (
						[
							<MenuItem key={queue.id} value={queue.id}>
								{queue.name}
							</MenuItem>,
							...(queue.options || []).map(opt => (
								<MenuItem key={`opt-${opt.id}`} value={`opt-${opt.id}`} style={{ paddingLeft: 30 }}>
									↳ {opt.title}
								</MenuItem>
							))
						]
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default QueueSelect;
